import { nodes } from './catalog.js'

const money = value => (typeof value === 'number' || typeof value === 'string') && String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 && Number.isSafeInteger(Math.round(Number(value) * 100))
export const saleSections = ['modulePrices', 'moduleIncrements', 'extraPrices']
export function salesTable(table, representativeId) {
  if (!table) return table
  const sales = table.representativeSales?.[representativeId] || {}
  return { ...table, ...Object.fromEntries(saleSections.map(section => [section, { ...table[section], ...sales[section] }])) }
}
export function salesErrors(sales, table) {
  if (!sales || typeof sales !== 'object' || Array.isArray(sales) || Object.keys(sales).some(key => !saleSections.includes(key))) return ['Informe somente preços de venda válidos.']
  const ids = new Set(nodes().map(node => node.id))
  for (const section of saleSections) {
    const prices = sales[section] || {}
    if (typeof prices !== 'object' || Array.isArray(prices) || Object.entries(prices).some(([id, value]) => !(section === 'extraPrices' ? ['users', 'pdvTerminals'].includes(id) : ids.has(id)) || !money(value) || !money(table[section]?.[id]))) return ['Preço de venda exige custo cadastrado e um valor não negativo.']
  }
  return []
}
export function saleFromMargin(cost, percent) {
  return Math.round(Number(cost) * (1 + Number(percent) / 100) * 100) / 100
}
export function saleMargin(cost, sale) {
  return Number(cost) > 0 ? (Number(sale) - Number(cost)) / Number(cost) * 100 : null
}
